<template>
    <div v-if="id">
        <div class="flex flex-wrap mb-4 input">
            <div class="input__label">
                <div class="text-xs leading-relaxed uppercase lg:text-sm font-700">{{ $t(fieldLabel) }}</div>
                
            </div>

            <div class="input__field ">
                <label v-for="(paymentMethod, index) of paymentMethods" :key="index" class="mb-2 paymentMethods label">
                    <input type="radio" :id="CreatePropertyId(fieldLabel, paymentMethod.id)" v-model="selectedPaymentMethod" :value="paymentMethod">
                    <span>{{ $t("paymentmethod."+paymentMethod.label) }}</span>
                    <div v-if="paymentMethod.label='Credit Card'" class="flex flex-no-wrap mb-2 ">
                        <div class="text-xs ml-6 pl-1 mr-2">{{ $t("paymentmethod.acceptdcards") }}</div>
                        <img class="mr-2 w-8" src="/assets/images/mastercard.png" alt="Mastercard" />
                        <img class="mr-2 w-8" src="/assets/images/discover.png" alt="Discover" />
                        <img class="mr-2 w-8" src="/assets/images/visa.png" alt="Visa" />
                    </div>
                </label>
            </div>
        </div>

        <div class="flex flex-wrap mb-4 input">
            <div id="paymentActions" ref="paymentActions" v-show="paymentMethodButton" v-html="paymentMethodButton" />
        </div>
    </div>
</template>

<script>
    import HtmlPropertyHelper from '@/mixins/HtmlPropertyHelper';
    import DateTimeHelper from '@/mixins/DateTimeHelper';
    import CaagApi from '@/mixins/CaagApi';

    // function cleanReservation() {
    //     alert('test2')
    // }

    export default {
        name: 'PaymentMethods',
        mixins: [HtmlPropertyHelper, DateTimeHelper, CaagApi],
        props: {
            fieldLabel: String,
            reservation: Object,
            id: Number
        },
        data: () => ({
            selectedPaymentMethod: null
        }),
        mounted() {
            this.initializePaymentMethods();
        },
        watch: {
            id: function(val) {
                if ( val && this.paymentMethods.length === 1 ) {
                    this.selectedPaymentMethod = this.paymentMethods[0]
                    this.getPaymentMethodButton(this.reservation, this.paymentMethods[0], this.$t('paymentmethod.pay'))
                }
            },
            selectedPaymentMethod: function(val) {
                this.reservation.id = this.id
                this.getPaymentMethodButton(this.reservation, val, this.$t('paymentmethod.pay'))
            },
            paymentMethodButton: function() {
                // 
            }
        },
        methods: {
            initializePaymentMethods: function() {
                this.getPaymentMethods();
            },
            cleanReservation: function() {
                alert('test')
            }
        }
    }
</script>

<style scoped>
  #paymentActions >>> ul {
    display: none;
  }

  #paymentActions >>> input[type=submit] {
    background-color: rgb(251, 154, 76);
    border-color: rgb(251, 154, 76);
    color: rgb(255, 255, 255);
  }
</style>
